import siteConfig from "../config/siteConfig";

const originalProducts = [
  {
    id: 1,
    name: "Harbor Utility Jacket",
    category: "Outerwear",
    price: 268,
    image: "/assets/products/01-harbor-utility-jacket.png",
    thumbnail: "/assets/products/01-harbor-utility-jacket-640.jpg",
    description:
      "A compact waxed-cotton jacket built around an offset closure, curved utility pockets and removable waist belt.",
    attributes: {
      material: "Waxed organic cotton",
      fit: "Cropped, adjustable waist",
      origin: "Designed for IRTRADECO",
      care: "Wipe clean; reproof when needed",
    },
    tags: ["new", "utility", "jacket", "teal"],
    sizes: ["XS", "S", "M", "L"],
    colors: ["Deep teal"],
    newArrival: true,
    bestseller: true,
    inStock: true,
  },
  {
    id: 2,
    name: "Contour Wide Trousers",
    category: "Trousers",
    price: 184,
    image: "/assets/products/02-contour-wide-trousers.png",
    thumbnail: "/assets/products/02-contour-wide-trousers-640.jpg",
    description:
      "Olive gabardine trousers with a folded side panel, cobalt topstitching and an adjustable tab waist.",
    attributes: {
      material: "Organic cotton gabardine",
      fit: "High rise, generous wide leg",
      origin: "Designed for IRTRADECO",
      care: "Machine wash cold",
    },
    tags: ["new", "trousers", "olive", "contrast stitch"],
    sizes: ["34", "36", "38", "40", "42"],
    colors: ["Field olive"],
    newArrival: true,
    bestseller: false,
    inStock: true,
  },
  {
    id: 3,
    name: "Signal Knit Vest",
    category: "Knitwear",
    price: 142,
    image: "/assets/products/03-signal-knit-vest.png",
    thumbnail: "/assets/products/03-signal-knit-vest-640.jpg",
    description:
      "A cobalt merino vest interrupted by asymmetrical ochre ribs and a diagonal knitted pocket.",
    attributes: {
      material: "Responsible merino wool",
      fit: "Relaxed, hip length",
      origin: "Designed for IRTRADECO",
      care: "Hand wash cold",
    },
    tags: ["new", "knitwear", "cobalt", "layering"],
    sizes: ["XS", "S", "M", "L"],
    colors: ["Cobalt / ochre"],
    newArrival: true,
    bestseller: true,
    inStock: true,
  },
  {
    id: 4,
    name: "Lantern Wrap Skirt",
    category: "Skirts",
    price: 156,
    image: "/assets/products/04-lantern-wrap-skirt.png",
    thumbnail: "/assets/products/04-lantern-wrap-skirt-640.jpg",
    description:
      "A technical-twill midi skirt with an angular wrap front, cobalt bar tacks and matte side buckle.",
    attributes: {
      material: "Recycled technical twill",
      fit: "Midi length, adjustable wrap",
      origin: "Designed for IRTRADECO",
      care: "Gentle machine wash",
    },
    tags: ["skirt", "burnt orange", "wrap", "graphic"],
    sizes: ["34", "36", "38", "40", "42"],
    colors: ["Burnt orange"],
    newArrival: false,
    bestseller: false,
    inStock: true,
  },
  {
    id: 5,
    name: "Axis Shirt Dress",
    category: "Dresses",
    price: 238,
    image: "/assets/products/05-axis-shirt-dress.png",
    thumbnail: "/assets/products/05-axis-shirt-dress-640.jpg",
    description:
      "A long cream poplin shirt dress traced by an off-centre cobalt placket and terracotta cuff tabs.",
    attributes: {
      material: "Organic cotton poplin",
      fit: "Straight, ankle length",
      origin: "Designed for IRTRADECO",
      care: "Machine wash at 30°C",
    },
    tags: ["new", "dress", "poplin", "cream"],
    sizes: ["XS", "S", "M", "L"],
    colors: ["Cream / cobalt"],
    newArrival: true,
    bestseller: false,
    inStock: true,
  },
  {
    id: 6,
    name: "Orbit Crescent Bag",
    category: "Accessories",
    price: 196,
    image: "/assets/products/06-orbit-crescent-bag.png",
    thumbnail: "/assets/products/06-orbit-crescent-bag-640.jpg",
    description:
      "A structured crescent bag with a braided teal handle, removable strap and understated oval hardware.",
    attributes: {
      material: "Vegetable-tanned leather",
      fit: "28 × 18 × 8 cm",
      origin: "Designed for IRTRADECO",
      care: "Condition with neutral leather balm",
    },
    tags: ["bag", "accessory", "burgundy", "leather"],
    sizes: ["One size"],
    colors: ["Burgundy / teal"],
    newArrival: false,
    bestseller: true,
    inStock: true,
  },
];

const apparelSizes = ["XS", "S", "M", "L", "XL"];
const numericSizes = ["34", "36", "38", "40", "42"];

const newProducts = [
  [7, "Dock Cropped Overshirt", "Outerwear", 198, "07-dock-cropped-overshirt", "A rust cotton overshirt with a cropped proportion, curved sleeves and oversized patch pockets.", "Organic cotton canvas", "Cropped, relaxed sleeves", "Rust", ["overshirt", "rust", "cotton", "cropped"], apparelSizes, true, true],
  [8, "Current Pleated Dress", "Dresses", 248, "08-current-pleated-dress", "A saturated cobalt midi dress shaped with fine vertical pleats and a clean belted waist.", "Recycled pleated satin", "Midi length, defined waist", "Blue", ["dress", "pleated", "cobalt", "occasion"], apparelSizes, true, false],
  [9, "Field Cargo Skirt", "Skirts", 168, "09-field-cargo-skirt", "An olive cargo skirt with a straight midi line, generous utility pockets and a front split.", "Organic cotton twill", "Straight midi fit", "Olive Green", ["skirt", "cargo", "olive", "utility"], numericSizes, false, true],
  [10, "Beacon Rib Knit", "Knitwear", 158, "10-beacon-rib-knit", "A soft cream mock-neck sweater with sculpted sleeves and a compact vertical rib.", "Responsible merino wool", "Regular fit, shaped sleeve", "Off-white", ["knitwear", "cream", "ribbed", "sweater"], apparelSizes, true, true],
  [11, "Frame Tailored Vest", "Tailoring", 176, "11-frame-tailored-vest", "A fitted burgundy waistcoat cut with an elongated point front and tonal horn buttons.", "Wool blend suiting", "Fitted, waist length", "Bordeaux", ["waistcoat", "tailoring", "burgundy", "layering"], apparelSizes, false, false],
  [12, "Tide Barrel Trousers", "Trousers", 188, "12-tide-barrel-trousers", "Deep teal trousers with a pleated waist and softly curved barrel leg.", "Organic cotton gabardine", "High rise, barrel leg", "Blue", ["trousers", "teal", "barrel", "tailored"], numericSizes, true, true],
  [13, "Angle Wrap Cardigan", "Knitwear", 172, "13-angle-wrap-cardigan", "An ochre merino cardigan with an asymmetric wrap front and offset button fastening.", "Responsible merino wool", "Relaxed asymmetric fit", "Camel", ["cardigan", "ochre", "wrap", "knitwear"], apparelSizes, true, false],
  [14, "Weather Shell Parka", "Outerwear", 286, "14-weather-shell-parka", "A navy weatherproof parka with a drawcord waist, storm hood and oversized pockets.", "Recycled technical cotton", "Relaxed, adjustable waist", "Navy", ["parka", "navy", "technical", "rainwear"], apparelSizes, false, true],
  [15, "Line Drape Blouse", "Shirts", 146, "15-line-drape-blouse", "A fluid cream blouse traced with narrow cobalt piping and a softly draped neckline.", "FSC viscose satin", "Fluid, hip length", "Off-white", ["blouse", "cream", "draped", "piping"], apparelSizes, true, false],
  [16, "Volume Cocoon Dress", "Dresses", 218, "16-volume-cocoon-dress", "A terracotta day dress with a rounded cocoon silhouette and discreet side pockets.", "Washed linen cotton", "Relaxed cocoon fit", "Brown", ["dress", "terracotta", "cocoon", "linen"], apparelSizes, false, true],
  [17, "Grid Quilted Gilet", "Outerwear", 192, "17-grid-quilted-gilet", "A forest green quilted gilet with a curved hem and substantial patch pockets.", "Recycled nylon", "Relaxed, longline back", "Olive Green", ["gilet", "quilted", "green", "layering"], apparelSizes, true, false],
  [18, "Cross Wrap Trousers", "Trousers", 196, "18-cross-wrap-trousers", "Cobalt wide trousers finished with a wrap waist and a long side tie.", "TENCEL twill", "High rise, wide leg", "Blue", ["trousers", "cobalt", "wrap", "wide leg"], numericSizes, true, true],
  [19, "Southbank Raincoat", "Outerwear", 278, "19-southbank-raincoat", "A mustard raincoat with a removable belt, generous collar and clean storm cuffs.", "Recycled waterproof cotton", "Straight, below-knee length", "Camel", ["raincoat", "mustard", "belted", "outerwear"], apparelSizes, false, true],
  [20, "Rhythm Rib Polo", "Knitwear", 154, "20-rhythm-rib-polo", "A fine burgundy rib-knit polo with a neat collar and tonal button placket.", "Responsible merino wool", "Close fit, hip length", "Bordeaux", ["polo", "burgundy", "ribbed", "knitwear"], apparelSizes, true, false],
  [21, "Drift Bias Skirt", "Skirts", 162, "21-drift-bias-skirt", "A deep teal satin skirt cut on the bias for an easy, fluid line.", "Recycled satin", "Midi length, bias cut", "Blue", ["skirt", "teal", "satin", "bias"], numericSizes, false, false],
  [22, "Chalk Wide Jeans", "Trousers", 174, "22-chalk-wide-jeans", "Off-white denim jeans with a high waist and an uninterrupted wide leg.", "Organic cotton denim", "High rise, wide leg", "Off-white", ["jeans", "denim", "cream", "wide leg"], numericSizes, true, true],
  [23, "Pulse Cropped Bomber", "Outerwear", 236, "23-pulse-cropped-bomber", "A vivid cobalt bomber balanced by a cropped body and full gathered sleeves.", "Recycled nylon", "Cropped, voluminous sleeve", "Blue", ["bomber", "cobalt", "cropped", "jacket"], apparelSizes, true, true],
  [24, "Column Twill Dress", "Dresses", 224, "24-column-twill-dress", "A minimal olive column dress with a precise sleeveless shoulder and ankle-grazing hem.", "Cotton linen twill", "Straight, ankle length", "Olive Green", ["dress", "olive", "column", "minimal"], apparelSizes, false, false],
  [25, "Trace Panel Sweatshirt", "Jersey", 132, "25-trace-panel-sweatshirt", "A rust loopback sweatshirt articulated with curved tonal seam panels.", "Organic cotton jersey", "Relaxed, regular length", "Brown", ["sweatshirt", "rust", "jersey", "panelled"], apparelSizes, true, false],
  [26, "Fold Pleated Culottes", "Trousers", 186, "26-fold-pleated-culottes", "Navy culottes constructed with deep knife pleats and a clean tailored waistband.", "Wool blend suiting", "High rise, cropped wide leg", "Navy", ["culottes", "navy", "pleated", "tailoring"], numericSizes, false, true],
  [27, "Knot Sculpted Top", "Tops", 148, "27-knot-sculpted-top", "A cream sleeveless top gathered into a sculptural side knot at the waist.", "Textured linen blend", "Fitted waist, asymmetric hem", "Off-white", ["top", "cream", "sculpted", "sleeveless"], apparelSizes, true, false],
  [28, "Route Utility Jumpsuit", "Jumpsuits", 242, "28-route-utility-jumpsuit", "A teal utility jumpsuit with a pointed collar, belted waist and straight leg.", "Organic cotton twill", "Relaxed, adjustable waist", "Blue", ["jumpsuit", "teal", "utility", "workwear"], apparelSizes, true, true],
  [29, "Check Signal Scarf", "Accessories", 94, "29-check-signal-scarf", "A brushed ochre scarf woven with an understated windowpane check and soft fringe.", "Responsible wool", "48 × 190 cm", "Camel", ["scarf", "ochre", "checked", "wool"], ["One size"], false, true],
  [30, "Fold Mini Crossbody", "Accessories", 164, "30-fold-mini-crossbody", "A compact burgundy crossbody bag with a curved flap and adjustable leather strap.", "Vegetable-tanned leather", "22 × 16 × 7 cm", "Bordeaux", ["bag", "crossbody", "burgundy", "leather"], ["One size"], true, false],
  [31, "Civic Structured Tote", "Accessories", 212, "31-civic-structured-tote", "A cobalt leather tote with a wide opening, reinforced handles and restrained structure.", "Responsibly sourced leather", "34 × 27 × 12 cm", "Blue", ["tote", "cobalt", "bag", "leather"], ["One size"], false, true],
  [32, "Arc Leather Boots", "Shoes", 228, "32-arc-leather-boots", "Deep teal ankle boots with a curved toe, block heel and clean inside zip.", "Vegetable-tanned leather", "True to size, 55 mm heel", "Blue", ["boots", "teal", "leather", "shoes"], ["36", "37", "38", "39", "40", "41"], true, true],
].map(([
  id,
  name,
  category,
  price,
  slug,
  description,
  material,
  fit,
  color,
  tags,
  sizes,
  newArrival,
  bestseller,
]) => ({
  id,
  name,
  category,
  price,
  image: `/assets/products/${slug}.png`,
  thumbnail: `/assets/products/${slug}-640.jpg`,
  description,
  attributes: {
    material,
    fit,
    origin: "Designed for IRTRADECO",
    care: material.toLowerCase().includes("leather") ? "Wipe clean; condition as needed" : "Gentle care according to label",
  },
  tags,
  sizes,
  colors: [color],
  newArrival,
  bestseller,
  inStock: true,
}));

const products = [...originalProducts, ...newProducts];

const productData = products.map((product) => {
  const imageBase = product.image.replace(/\.png$/, "");

  return {
    ...product,
    brand: siteConfig.brandName,
    images: [
      product.image,
      `${imageBase}-back.png`,
      `${imageBase}-three-quarter.png`,
    ],
    material: product.attributes.material,
    size: product.sizes,
    features: [
      product.attributes.fit,
      product.attributes.origin,
      product.attributes.care,
    ],
  };
});

export default productData;
